/**
 * 내 계정 설정 › 연계 화면 열기 (65차, 2026-09-16)
 *  법령별 통관정보·요건확인기관·통합공고/세관장확인·세번 상세처럼 화면 사이를 오가는 링크를
 *  새 탭(기본)으로 열지, 같은 탭에서 이동할지 고른다. 브라우저에만 저장(localStorage), 계정 동기화 없음.
 */
import { LINK_TARGETS, setLinkTarget, useLinkTarget } from "../audit/reqLinks";

export default function LinkTargetSetting({ styles = {} }) {
  const target = useLinkTarget();
  const row = { display: "flex", alignItems: "flex-start", gap: 10, padding: "8px 0", cursor: "pointer" };
  return (
    <section style={styles.section} data-testid="link-target-setting">
      <div style={styles.sectionHead}>
        <h3 style={styles.sectionTitle}>연계 화면 열기</h3>
      </div>
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 6, lineHeight: 1.6 }}>
        세번 상세에서 법령·통관정보·요건확인기관으로, 통관정보에서 세번 상세로 가는 링크를 어떻게 열지 정합니다.
        어느 쪽이든 Ctrl 클릭·휠 클릭은 브라우저가 새 탭으로 엽니다.
      </div>
      {LINK_TARGETS.map((opt) => (
        <label key={opt.id} style={row}>
          <input
            type="radio"
            name="loginhs-link-target"
            value={opt.id}
            checked={target === opt.id}
            onChange={() => setLinkTarget(opt.id)}
            data-testid={`link-target-${opt.id}`}
            style={{ marginTop: 3 }}
          />
          <span>
            <span style={{ fontWeight: 600 }}>{opt.label}</span>
            {opt.id === "tab" && <span style={{ color: "#6b7280", fontSize: 12, marginLeft: 6 }}>기본</span>}
            <div style={{ fontSize: 12.5, color: "#6b7280", lineHeight: 1.5 }}>{opt.desc}</div>
          </span>
        </label>
      ))}
    </section>
  );
}
